<template>
  <teleport to="#teleport-modal">
    <transition name="fade">
      <div
        v-show="showDialog"
        class="fixed top-0 left-0 w-full h-full flex items-center justify-center z-40"
        style="background: rgba(152, 163, 190, 0.3)"
      >
        <div class="bg-white p-8 rounded-lg relative" style="min-width: 560px">
          <div v-if="state.step == 1">
            <div class="flex w-full">
              <div
                class="font-semibold text-base text-secondary-main leading-7 mb-4 w-full"
              >
                PRONIパートナーを招待する
              </div>
            </div>
            <div class="font-light text-gray5 leading-6 pb-6 h-auto">
              <div style="max-width: 500px">
                <div class="pb-2">
                  <label
                    class="text-secondary-main leading-5 text-sm font-semibold"
                    >送信先</label
                  >
                </div>
                <div>
                  <div
                    ref="inviteEmailWrapperRef"
                    @click="focusNewEmail()"
                    :class="{
                      'vue-input-tag-wrapper--active': state.isInputActive,
                    }"
                    class="vue-input-tag-wrapper"
                  >
                    <div
                      v-for="(email, index) in state.emails"
                      :key="index"
                      :class="inputTagClass(index)"
                      @click="editLastEmail(index)"
                    >
                      <span class="mr-1">
                        <img
                          style="width: 14px; height: 14px"
                          src="@/assets/icons/AlertCircle.svg"
                      /></span>
                      <div class="justify-center">{{ email.text }}</div>
                      <img
                        class="remove cursor-pointer hover:button"
                        @click.prevent.stop="removeEmail(index)"
                        src="@/assets/icons/Exit.svg"
                      />
                    </div>
                    <input
                      ref="inviteEmailRef"
                      type="text"
                      v-model="state.newEmail"
                      v-on:keydown.delete.stop="removeLastEmail"
                      v-on:keydown="addNewEmail"
                      v-on:blur="handleInputBlur"
                      v-on:focus="handleInputFocus"
                      v-on:paste="handlePaste"
                      class="new-tag"
                      :placeholder="
                        state.emails.length ? '' : '例）info@proni.co.jp'
                      "
                    />
                  </div>
                </div>
                <div v-if="state.invalidEmails.length > 0">
                  <span class="flex text-coral-main text-sm leading-6"
                    >メールアドレスが正しく入力されていません</span
                  >
                  <span
                    @click="removeInvalidEmails"
                    class="flex text-secondary-main text-sm leading-6 cursor-pointer"
                    style="text-decoration: underline"
                  >
                    エラーのある項目をすべてを削除する</span
                  >
                </div>
                <div v-if="state.duplicatedEmails.length > 0">
                  <span class="flex text-coral-main text-sm leading-6"
                    >同じアドレスが複数含まれています</span
                  >
                  <span
                    @click="removeDuplicatedEmails"
                    class="flex text-secondary-main text-sm leading-6 cursor-pointer"
                    style="text-decoration: underline"
                  >
                    重複を削除する</span
                  >
                </div>
                <div v-if="state.registeredEmails.length > 0">
                  <span
                    v-if="state.registeredEmails.length === 1"
                    class="flex text-coral-main text-sm leading-6"
                    >{{
                      state.registeredEmails[0].text
                    }}は既に参加しています</span
                  >
                  <span v-else class="flex text-coral-main text-sm leading-6"
                    >{{
                      state.registeredEmails.length
                    }}名のユーザーが既に参加しています</span
                  >
                  <span
                    @click="removeRegisteredEmails"
                    class="flex text-secondary-main text-sm leading-6 cursor-pointer"
                    style="text-decoration: underline"
                  >
                    重複を削除する</span
                  >
                </div>
              </div>
            </div>
            <div class="text-right">
              <button
                class="leading-10 font-semibold px-6 rounded mr-2 focus:outline-none text-gray-92 border hover:button"
                @click="closeDialog"
              >
                キャンセル
              </button>
              <button
                class="leading-10 font-semibold px-5 rounded focus:outline-none border-gray3 text-white bg-secondary-main"
                :class="{
                  'opacity-25':
                    state.hasErrors ||
                    (state.emails.length == 0 && state.newEmail == ''),
                  'hover:button': !state.hasErrors && state.emails.length > 0,
                }"
                @click="sendInvite"
              >
                招待メールを送信する
              </button>
            </div>
            <div class="flex mt-4">
              <transition name="fade-fast">
                <div class="relative">
                  <button
                    class="flex p-2 rounded outline-none"
                    :class="{ 'bg-slate-100': state.isInviteLinkCopied }"
                    @click="generateInviteLink"
                    @mouseover="state.annotation.isShow = true"
                    @mouseleave="
                      state.annotation.isShow = false;
                      state.isInviteLinkCopied = false;
                    "
                  >
                    <img
                      style="width: 18px; height: 18px; margin-top: 2px"
                      src="@/assets/icons/Clip.svg"
                    />
                    <span class="ml-2 text-gray5">
                      招待リンクをコピーする
                      <input
                        type="hidden"
                        ref="inviteLinkRef"
                        id="inviteLink"
                        :value="state.inviteLink"
                      />
                    </span>
                    <div
                      v-show="state.annotation.isShow"
                      style="position: absolute; width: 500px; z-index: 18"
                    >
                      <div
                        style="display: block; position: absolute"
                        class="top"
                      >
                        <div
                          class="annotation-content text-white bg-secondary-main py-2 px-4 rounded-lg text-left"
                          style="
                            font-size: 13px;
                            line-height: 18px;
                            position: relative;
                            display: block;
                          "
                        >
                          <div v-html="state.annotation.content"></div>
                        </div>
                      </div>
                    </div>
                  </button>
                </div>
              </transition>
            </div>
          </div>
          <div v-if="state.step == 2">
            <div class="flex w-full justify-center">
              <div
                class="flex rounded-full w-16 h-16 items-center justify-center"
                style="background-color: rgba(108, 126, 206, 0.1)"
              >
                <img class="w-8 h-8" src="@/assets/icons/CheckBlue.svg" />
              </div>
            </div>
            <div
              class="text-secondary-main text-center font-semibold text-xl leading-8 mt-4"
            >
              送信済み
            </div>
            <div class="mt-4">
              <div
                v-for="(email, index) in state.sentEmails"
                class="flex items-center"
                :key="index"
              >
                <img
                  class="w-4 ml-2 mr-1"
                  src="@/assets/icons/AddAccount.svg"
                />
                <span class="text-secondary-main font-semibold text-sm"></span>
                {{ email.text }}
              </div>
            </div>
            <div
              class="text-secondary-main text-sm leadning-6 justify-center text-center mt-4"
            >
              PRONIパートナーを招待しました。
            </div>
            <div class="text-right mt-8">
              <button
                class="leading-10 font-semibold px-6 rounded mr-2 focus:outline-none text-gray-92 border hover:button"
                @click="state.step = 1"
              >
                PRONIパートナーをもっと招待する
              </button>
              <button
                class="leading-10 font-semibold px-5 rounded focus:outline-none hover:button border-gray3 text-white bg-secondary-main"
                @click="closeDialog"
              >
                終了
              </button>
            </div>
          </div>
          <div class="absolute" style="top: 32px; right: 24px">
            <div class="flex-end w-8">
              <img
                @click="closeDialog"
                src="@/assets/icons/Exit.svg"
                class="cursor-pointer hover:button"
              />
            </div>
          </div>
        </div>
      </div>
    </transition>
  </teleport>
</template>
<script>
import { inject, computed, nextTick, reactive, ref } from 'vue';

import axios from '@/utils/axiosAuth.js';
import rules from '@/utils/validateRules.js';

export default {
  props: {
    showDialog: Boolean,
    addTagOnKeys: {
      type: Array,
      default: function () {
        return [
          13, // Return
          188, // Comma ','
          9, // Tab
          32, // Space
        ];
      },
    },
    addTagOnBlur: {
      type: Boolean,
      default: true,
    },
    limit: {
      type: Number,
      default: 100,
    },
  },
  emits: ['close-dialog'],
  setup(props, { emit }) {
    const globalMethods = inject('globalMethods');
    const globalStore = inject('globalStore');
    const state = reactive({
      step: 1,
      isInputActive: false,
      isProcessing: false,
      emails: [],
      sentEmails: [],
      newEmail: '',
      isInviteLinkCopied: false,
      inviteLink: '',
      hasErrors: computed(() => {
        return (
          state.invalidEmails.length > 0 ||
          state.duplicatedEmails.length > 0 ||
          state.registeredEmails.length > 0
        );
      }),
      duplicatedEmails: computed(() => {
        return state.emails.filter((email) => email.isDuplicated);
      }),
      registeredEmails: computed(() => {
        return state.emails.filter((email) => email.isRegistered);
      }),
      invalidEmails: computed(() => {
        return state.emails.filter((email) => email.isInvalid);
      }),

      isLimit: computed(() => {
        return props.limit > 0 && Number(props.limit) === state.emails.length;
      }),
      annotation: {
        isShow: false,
        content: computed(() => {
          if (state.isInviteLinkCopied) {
            return 'リンクがコピーされました、リンクの有効期限は7日間です';
          }
          return 'このリンクでメンバーを招待する';
        }),
      },
    });

    const inviteEmailRef = ref(null);
    const inviteLinkRef = ref(null);
    const inviteEmailWrapperRef = ref(null);
    const focusNewEmail = () => {
      if (inviteEmailRef.value) {
        inviteEmailRef.value.focus();
      }
    };

    const handleInputFocus = () => {
      state.isInputActive = true;
    };

    const handleInputBlur = (e) => {
      state.isInputActive = false;
      addNewEmail(e);
    };

    const removeEmail = (index) => {
      state.emails.splice(index, 1);
    };

    const removeLastEmail = () => {
      if (state.newEmail) {
        return;
      }
      state.emails.pop();
    };
    const editLastEmail = (index) => {
      if (state.newEmail !== '' || index < state.emails.length - 1) {
        return;
      }
      let email = state.emails.pop();
      state.newEmail = email.text;
    };
    const scrollToBottom = (scrollBehavior = {}) => {
      if (inviteEmailWrapperRef.value) {
        inviteEmailWrapperRef.value.scrollTo({
          top: inviteEmailWrapperRef.value.scrollHeight + 100,
          ...scrollBehavior,
        });
      }
    };

    const generateInviteLink = async () => {
      // Generate invite link
      state.inviteLink = await axios
        .post('/sellers/invite-link/create')
        .then((response) => response.data.invite_link)
        .catch((e) => {
          globalMethods.updateModal(
            true,
            'URLが正しくないか、通信エラーが発生しました。',
            e.systemMessage || '',
            e.callback
          );
          globalMethods.sendLog(e);
        });
      // Wait until the link is rendered in the DOM
      await nextTick();
      // Copy to clipboard
      if (inviteLinkRef.value && state.inviteLink !== '') {
        inviteLinkRef.value.setAttribute('type', 'text');
        inviteLinkRef.value.select();

        try {
          let successful = document.execCommand('copy');
          if (successful) {
            state.isInviteLinkCopied = true;
            state.inviteLink = '';
          }
        } catch (err) {
          alert('エラーが発生しました。コピーできませんでした。');
        }

        /* unselect the range */
        inviteLinkRef.value.setAttribute('type', 'hidden');
        window.getSelection().removeAllRanges();
      }
    };

    const sendInvite = async () => {
      if (state.hasErrors || state.emails.length == 0) {
        return;
      }
      const postData = {
        emails: state.emails.map((email) => email.text),
      };
      await axios
        .post(`sellers/invite-send`, postData)
        .then((response) => {
          if (response.data.result === true) {
            state.step = 2;
            state.sentEmails = state.emails;
            state.emails = [];
          } else {
            globalMethods.updateModal(
              true,
              '招待メールを送信できません。',
              response.data.message
            );
          }
        })
        .catch((e) => {
          globalMethods.updateModal(
            true,
            'エラーが発生しました。',
            '',
            e.callback
          );
          globalMethods.sendLog(e);
        });
    };

    const addNewEmail = async (e) => {
      const keyShouldAddEmail = e
        ? props.addTagOnKeys.indexOf(e.keyCode) !== -1
        : true;
      const typeIsNotBlur = e && e.type !== 'blur';
      if (
        (!keyShouldAddEmail && (typeIsNotBlur || !props.addTagOnBlur)) ||
        state.isLimit ||
        state.isProcessing
      ) {
        return;
      }
      if (state.newEmail === '') {
        return;
      }
      state.isProcessing = true;
      const emailText = state.newEmail.trim();

      let emails = [
        {
          text: emailText,
          isInvalid: false,
          isDuplicated: false,
          isRegistered: false,
        },
      ];
      // Validate error
      emails = await validateEmailHasError(emails, state.emails);
      emails.forEach((email) => {
        state.emails.push(email);
      });
      state.newEmail = '';
      state.isProcessing = false;
      e && e.preventDefault();
      await nextTick();
      scrollToBottom({ behavior: 'smooth' });
      focusNewEmail();
    };

    const removeDuplicatedEmails = () => {
      state.emails = state.emails.filter((email) => !email.isDuplicated);
    };

    const removeInvalidEmails = () => {
      state.emails = state.emails.filter((email) => !email.isInvalid);
    };

    const removeRegisteredEmails = () => {
      state.emails = state.emails.filter((email) => !email.isRegistered);
    };

    const validateEmailHasError = async (emails, currentEmails) => {
      for (const [key, email] of Object.entries(emails)) {
        // Is email invalid
        if (rules.validate(email.text, 'required|email') !== true) {
          emails[key].isInvalid = true;
        }
        // Check duplicated with current emails
        for (const [i] of Object.entries(currentEmails)) {
          if (currentEmails[i].text === email.text) {
            emails[key].isDuplicated = true;
          }
        }
        // Check duplicated isself
        for (let j = emails.length - 1; j > key; j--) {
          if (emails[j].text === email.text) {
            emails[j].isDuplicated = true;
          }
        }
      }

      let arrayOfEmails = emails.map((email) => email.text);
      await axios
        .get('/users/email', { params: { emails: arrayOfEmails } })
        .then((res) => {
          if (res.data.data.length) {
            for (let i = 0; i < emails.length; i++) {
              if (res.data.data.includes(emails[i].text)) {
                emails[i].isRegistered = true;
              }
            }
          }
        });
      return emails;
    };

    const closeDialog = () => {
      // Reset state
      state.step = 1;
      state.emails = [];
      state.sentEmails = [];
      emit('close-dialog');
    };

    const handlePaste = async (event) => {
      let text = (event.clipboardData || window.clipboardData).getData('text');
      let emailTexts = text.split(/(?:,| |\n|;)+/);
      let emails = emailTexts.map((emailText) => {
        return {
          text: emailText,
          isInvalid: false,
          isDuplicated: false,
          isRegistered: false,
        };
      });
      emails = await validateEmailHasError(emails, state.emails);
      state.emails = state.emails.concat(emails);
      state.newEmail = '';
    };

    const inputTagClass = (emailIndex) => {
      if (
        typeof state.emails[emailIndex] !== 'undefined' &&
        (state.emails[emailIndex].isInvalid ||
          state.emails[emailIndex].isDuplicated ||
          state.emails[emailIndex].isRegistered)
      ) {
        return 'input-tag font-semibold error cursor-pointer';
      }
      if (state.newEmail === '' && emailIndex === state.emails.length - 1) {
        return 'input-tag font-semibold cursor-pointer';
      }
      return 'input-tag font-semibold';
    };

    return {
      globalStore,
      state,
      inviteEmailWrapperRef,
      inviteEmailRef,
      inviteLinkRef,
      focusNewEmail,
      addNewEmail,
      removeEmail,
      editLastEmail,
      removeLastEmail,
      removeInvalidEmails,
      removeDuplicatedEmails,
      removeRegisteredEmails,
      handleInputBlur,
      handleInputFocus,
      handlePaste,
      generateInviteLink,
      sendInvite,
      closeDialog,
      inputTagClass,
    };
  },
};
</script>

<style lang="scss" scoped>
.vue-input-tag-wrapper {
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #dde1ed;
  overflow: scroll;
  padding-left: 4px;
  padding-top: 4px;
  cursor: text;
  text-align: left;
  -webkit-appearance: textfield;
  display: flex;
  flex-wrap: wrap;
  min-height: 77px;
  line-height: 20px;
  max-width: 500px;
  max-height: 200px;
  .input-tag {
    background-color: #f1f2f6;
    border-radius: 4px;
    color: #102855;
    display: inline-flex;
    font-size: 14px;
    margin-bottom: 8px;
    margin-right: 8px;
    padding: 3px 8px;
    height: 26px;
    align-items: center;
    span {
      display: none;
    }
    &.error {
      border: 1px solid #de2d2d;
      background-color: #fff;
      span {
        display: block;
      }
    }
    img.remove {
      width: 10px;
      height: 10px;
      margin-left: 8px;
    }
  }
  .new-tag {
    background: transparent;
    border: 0;
    color: #102855;
    font-size: 14px;
    margin-bottom: 6px;
    margin-top: 1px;
    outline: none;
    padding: 4px;
    padding-left: 0;
    flex-grow: 1;
    line-height: 20px;
    height: 26px;
    margin-bottom: 8px;
    margin-right: 8px;
    padding: 3px 8px;
    width: 70px;
  }
}
.annotation-content::after {
  position: absolute;
  content: '';
  display: block;
  width: 10px;
  height: 10px;
  background: #1b3360;
  transform: rotate(45deg);
}
.top {
  bottom: 24px;
  .annotation-content {
    left: calc(-3%);
    &::after {
      bottom: -4px;
      left: calc(60% + 2px);
    }
  }
}
</style>
